import history from './history';
import { getRuleCategoryUrl } from '../services/RuleCategory';
import { SimulationPath } from '../main/main-content/simulation/simulation.paths';

export function redirectTo(redirection, state) {
    history.push({
        pathname: redirection,
        state: state
    });
}

export function redirectToPlayerDetails(playerId, subtitle) {
    redirectTo('/players/player-details', { playerId: playerId, subtitle });
    // todo maybe add the id of the player eg: /players/{player_id}/player-details
}

export function redirectToDismissAlert(ruleCategory, alert) {
    redirectTo(
        '/alerts/' + getRuleCategoryUrl(ruleCategory) + '/dismiss-alert',
        { alert: alert }
    );
}

export function redirectToDismissedAlerts(ruleCategory) {
    redirectTo('/alerts/dismissed/' + getRuleCategoryUrl(ruleCategory), {
        ruleCategory: ruleCategory
    });
}

export function redirectToUserDetails(userId, subtitle) {
    redirectTo(`/users/details/${userId}`, { subtitle });
}

/* The audit trail, looking at the events about a jurisdiction (a sandbox) when one is named. */
export function redirectToAudit(jurisdictionCode) {
    history.push({
        pathname: '/audit',
        search: jurisdictionCode
            ? `?jurisdiction=${encodeURIComponent(jurisdictionCode)}`
            : ''
    });
}

/* A new run made from an earlier one: the form is filled in from the run in the address (the query is not part of the pathname). */
export function redirectToNewRunFrom(runId) {
    history.push({
        pathname: SimulationPath.NEW_RUN,
        search: `?from=${encodeURIComponent(runId)}`
    });
}

export function goBack() {
    history.goBack();
}
